import { render } from "./JSON-Viewer.vue?vue&type=template&id=51fc1fe1&scoped=true"
import script from "./JSON-Viewer.vue?vue&type=script&lang=js"
export * from "./JSON-Viewer.vue?vue&type=script&lang=js"

import "./JSON-Viewer.vue?vue&type=style&index=0&id=51fc1fe1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51fc1fe1"]])

export default __exports__